// extracted by mini-css-extract-plugin
module.exports = {"dfsHeader":"dfsHeader_dfsHeader__uyVTO"};